var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box as MuiBox, Tooltip } from '@mui/material';
import { StoryIcon } from '../atoms/Icons';
var Box = styled(MuiBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  min-width: 32px;\n\n  a {\n    color: #333;\n    display: block;\n  }\n"], ["\n  text-align: center;\n  min-width: 32px;\n\n  a {\n    color: #333;\n    display: block;\n  }\n"])));
var OfferListStoryIcon = function (_a) {
    var storyUrls = _a.offerList.storyUrls, _b = _a.blankValue, blankValue = _b === void 0 ? '' : _b, _c = _a.showTitle, showTitle = _c === void 0 ? false : _c;
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    var storyUrl = storyUrls[i18n.language];
    if (!storyUrl)
        return React.createElement(React.Fragment, null, blankValue);
    return (React.createElement(Tooltip, { title: t('links.story') },
        React.createElement(Box, null,
            React.createElement("a", { href: storyUrl, target: "_blank", rel: "noopener noreferrer" },
                React.createElement(StoryIcon, null)),
            showTitle && React.createElement("div", null, t('links.story')))));
};
export default OfferListStoryIcon;
var templateObject_1;
